"use strict";

(function () {
  'use strict';

  angular.module('app.filters', ['filter.upcoming-trips', 'filter.past-trips', 'filter.current-trips', 'special-filters', 'filter.relative-date', 'filter.cancelled-trips', 'filter.available-options', 'filter.group-by', 'filter.package-specials', 'filter.pending-connections', 'filter.truncate', 'filter.negative-amount', 'filter.dates']);
})();